import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import FlatFee from '../../entities/flatFee';
import Invoice from '../../entities/invoice';
import Task from '../../entities/task';
export function deleteFlatFee(flatFee: FlatFee, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = flatFee.id;}
const _work = workingSet();
store.getState().tasks.getMappingFor('flatFeeBucket', flatFee.id).filter(taskTemp => taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
if (_task.flatFeeBucket === flatFee.id) {
_task.flatFeeBucket = null;
_task.flatFeeMilestoneBucket = null;
}
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});



flatFee.status = 'D';
flatFee.addedOn = newHRTimestamp();
flatFee.addedBy = getCurrentUserId();
flatFee.importSource = targetImportSource;
flatFee.importId = mergeId;
store.dispatch(Actions.FlatFeeActions.removeFlatFeeQueue(flatFee));
}
export function replaceFlatFee(flatFee: FlatFee, replaceWith: FlatFee, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = flatFee.id;}
const _work = workingSet();
store.getState().tasks.getMappingFor('flatFeeBucket', flatFee.id).filter(taskTemp => taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
if (_task.flatFeeBucket === flatFee.id) {
_task.flatFeeBucket = replaceWith.id;
_task.flatFeeMilestoneBucket = null;
}
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});



return flatFee;
}
export function deleteImpactFlatFee(flatFee: FlatFee) {
const impacts: string[] = [];
const state = store.getState();
const invoiceFlatFeeIdsImpact = state.invoices.getMappingFor('flatFeeIds', flatFee.id).filter(invoice => invoice.status !== 'D');
invoiceFlatFeeIdsImpact.forEach(() => impacts.push('invoices'));
const taskFlatFeeBucketImpact = state.tasks.getMappingFor('flatFeeBucket', flatFee.id).filter(task => task.status !== 'D');
taskFlatFeeBucketImpact.forEach(() => impacts.push('tasks'));



return util.countDistinct(impacts);
}
